import { ref } from 'vue';
import AiAPI from 'custom/api/ai';

// A conversation's assistant, the assistant's state in it and (for admins) what AI cost in it, fetched once for the
// components that show them
const byConversation = ref({});
const inFlight = {};

export function useConversationAi() {
  const infoFor = conversationId =>
    byConversation.value[conversationId] || null;

  const refresh = conversationId => {
    inFlight[conversationId] ||= AiAPI.conversationState(conversationId)
      .then(({ data }) => {
        byConversation.value = {
          ...byConversation.value,
          [conversationId]: data,
        };
        return data;
      })
      .finally(() => {
        delete inFlight[conversationId];
      });
    return inFlight[conversationId];
  };

  return { infoFor, refresh };
}
